import * as React from 'react';

import styles from './AnalysisTextArea.module.scss';
import TurndownService from 'turndown';
import CustomRichTextEditor from './RichTextEditor';

interface AnalysisTextAreaOwnProps {
  rawValue: string;
  onChange: (markdown: string, rawContent: string) => void;
}

export const AnalysisTextArea: React.FC<AnalysisTextAreaOwnProps> = ({
  rawValue,
  onChange,
}) => {
  const handleChangeEditor = (content: any) => {
    var turndownService = new TurndownService({
      emDelimiter: '*',
      bulletListMarker: '-',
      strongDelimiter: '__',
    });

    turndownService.addRule('textDecorations', {
      filter: ['span'],
      replacement: function (content: any, node: any) {
        const style = node.getAttribute('style');
        let isStrong = style && style.includes('font-weight');
        const isUnderlined = style && style.includes('underline');
        const isItalic = node.getElementsByTagName('em').length > 0;
        let isStringEmpty = !content.replace(/\s/g, '').length;

        isStrong &&
          isItalic &&
          isUnderlined &&
          node.getElementsByTagName('span').length > 0 &&
          (isStringEmpty = true);

        isUnderlined &&
          node.getElementsByTagName('span') &&
          node.getElementsByTagName('span')[0] &&
          node.getElementsByTagName('span')[0].getAttribute('style') &&
          node
            .getElementsByTagName('span')[0]
            .getAttribute('style')
            .includes('font-weight') &&
          (isStrong = true);

        return isStringEmpty
          ? ''
          : isStrong && isUnderlined
          ? `__<ins>${content.replace(/_/, '')}</ins>__`
          : isItalic && isUnderlined
          ? `*<ins>${content}</ins>*`
          : isStrong
          ? ` __${content}__ `
          : isUnderlined
          ? '<ins>' + content + '</ins>'
          : content;
      },
    });
    var markdown: string = content ? turndownService.turndown(content) : '';

    onChange(markdown, content);
  };

  return (
    <div className={styles.container + ' notranslate'}>
      <CustomRichTextEditor
        change={(e: Event) => handleChangeEditor(e)}
        value={rawValue}
      />
    </div>
  );
};
